import React, { Component } from "react";
import arrPrev from '../../images/line-md_arrow-left.png';
import nextArrow from '../../images/line-md_arrow-right.png';
import * as Constanti from '../../Utils/constants.js';
import '../../style/categoriauno.css';
import '../../style/generic.css';
import Slider from "react-slick";
import axios from "axios";
import { Link } from "react-router-dom";
import CardTwo from "../cards/cardTwo.js";
import Protagonisti from "../protagonisti/protagonisti.js";



class ProtagonistiHome extends Component{
  constructor(props){
    
    super(props);
    this.state = {
      personaggi: [],
      }
      this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
}

next() {
  this.slider.slickNext();
}
previous() {
  this.slider.slickPrev();
}


  componentDidMount() {
    const api = Constanti.url_Backend + "allPersonaggi";
    axios.get(api)
      .then(res => {
        const v = res.data.data;
        this.setState({
          personaggi: v,
        }, () => {
        });
      })
      .catch(err => console.error(err));

  }

  render(){
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      centerMode: false,
      centerPadding: '60px',
      slidesToShow:1, 
      slidesToScroll: 1,
      variableWidth: true,
    };
    const { personaggi } = this.state;
  return (
    <section className="categorysection">
    <div className="container">
    <div className="slider-wrapper">
    <div className="slider-title-wrapper">
      <h2 className="h2">Ospiti speciali</h2>
    </div>
    <div className="slider-hover-wrapper">
    <div className="divButton ">
      <button className="buttonSlider left" onClick={this.previous}>
          <img className="prev-slick-arrow" height={51}  width={51} src={arrPrev}/>
          </button>
          <button className="buttonSlider right" onClick={this.next}>
          <img className="next-slick-arrow" src={nextArrow}  height={51}  width={51} />
          </button>
    </div>
    <div className="container-home slider-container protagonisti" >
    <Slider ref={c => (this.slider = c)} {...settings}>
    {personaggi != null && personaggi?.map(el => (
      <div className="paddingRight5" key={el}>
    <Link to={'/protagonisti/'+el.id} key={el}>
         <div  className="flex vertical align-start" >
        
         <img src={Constanti.url_img_new+el.foto} alt="protagonista" className="avatar"></img>
         <span className="namePersonaggio padding-left-8">{el.nome} {el.cognome}</span>
         </div>
         </Link>
    </div>
    ))}
     </Slider>
   </div>
   </div>
   </div>
   </div>
   </section>
    )
}
}
export default ProtagonistiHome; 





